import React, { Component } from 'react';
import { Container, ListGroup, CardDeck, Card, Form, Button } from 'react-bootstrap'
import web3 from '../ethereum/web3'
import Header from './Header'
import Loading from './Loading'
import token from '../ethereum/token'

class Tokens extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      symbol: '',
      decimals: '',
      totalSupply: '',
      founder: '',
      ownerAddress: '',
      spenderAddress: '',
      allowance: '',
      balanceAccount: '',
      balance: '',
      approveAddress: '',
      approveAmount: '',
      transferTo: '',
      transferAmount: '',
      from: '',
      to: '',
      transferFromAmount: '',
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      loading5: false
    }
  }

  async componentDidMount() {
    const { params } = this.props.match
    const tokenDetail = token(params.id)

    const name = await tokenDetail.methods.name().call()
    const symbol = await tokenDetail.methods.symbol().call()
    const decimals = await tokenDetail.methods.decimals().call()
    const totalSupply = await tokenDetail.methods.totalSupply().call()

    this.setState({
      name,
      symbol,
      decimals,
      totalSupply
    })
  }

  checkAllowance = async (event) => {
    event.preventDefault();

    this.setState({ loading1: true });

    try {
      const { params } = this.props.match
      const tokenDetail = token(params.id)
      const allowance = await tokenDetail.methods.allowance(this.state.ownerAddress, this.state.spenderAddress).call()
      this.setState({ allowance })
    } catch (err) {
      window.alert(err.message)
    }

    this.setState({ loading1: false });
  }

  checkBalance = async (event) => {
    event.preventDefault();

    this.setState({ loading2: true });

    try {
      const { params } = this.props.match
      const tokenDetail = token(params.id)
      const balance = await tokenDetail.methods.balanceOf(this.state.balanceAccount).call()
      this.setState({ balance })
    } catch (err) {
      window.alert(err.message)
    }

    this.setState({ loading2: false });
  }

  approve = async (event) => {
    event.preventDefault();

    this.setState({ loading3: true });

    try {
      const { params } = this.props.match
      const tokenDetail = token(params.id)
      const accounts = await web3.eth.getAccounts()
      await tokenDetail.methods.approve(this.state.approveAddress, this.state.approveAmount)
        .send({ from: accounts[0] })

    } catch (err) {
      window.alert(err.message)
    }

    this.setState({ loading3: false });
  }

  transfer = async (event) => {
    event.preventDefault();

    this.setState({ loading4: true });

    try {
      const { params } = this.props.match
      const tokenDetail = token(params.id)
      const accounts = await web3.eth.getAccounts()
      await tokenDetail.methods.transfer(this.state.transferTo, this.state.transferAmount)
        .send({ from: accounts[0] })

    } catch (err) {
      window.alert(err.message)
    }

    this.setState({ loading4: false });
  }


  transferFrom = async (event) => {
    event.preventDefault();

    this.setState({ loading5: true });

    try {
      const { params } = this.props.match
      const tokenDetail = token(params.id)
      const accounts = await web3.eth.getAccounts()
      await tokenDetail.methods.transferFrom(this.state.from, this.state.to, this.state.transferFromAmount)
        .send({ from: accounts[0] })

    } catch (err) {
      window.alert(err.message)
    }

    this.setState({ loading5: false });
  }


  render() {

    return (
      <Container>
        <Header />
        <div style={{ marginTop: "30px" }} className="text-center">
          <div>
            <CardDeck>
              <Card className="text-center">
                <Card.Body>
                  <Card.Title>{this.state.name}</Card.Title>
                  <ListGroup variant="flush">
                    <ListGroup.Item>Symbol: {this.state.symbol}</ListGroup.Item>
                    <ListGroup.Item>Decimals: {this.state.decimals}</ListGroup.Item>
                    <ListGroup.Item>Total Supply: {this.state.totalSupply}</ListGroup.Item>
                    <ListGroup.Item>Contract Address: {this.props.match.params.id}</ListGroup.Item>
                  </ListGroup>
                </Card.Body>
              </Card>
              <Card>
                <Card.Body>
                  <Card.Title>Check Allowance</Card.Title>
                  <Card.Text>
                    Check the amount which the spender is allowed to withdraw from the owner
                  </Card.Text>
                  <Form onSubmit={this.checkAllowance}>
                    <Form.Group>
                      <Form.Label>Owner's Address</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ ownerAddress: event.target.value })}
                        type="text"
                        placeholder="Owner's ethereum address"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Spender's Address</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ spenderAddress: event.target.value })}
                        type="text"
                        placeholder="Spender's ethereum address"
                      />
                    </Form.Group>
                    <Button variant="success" type="submit">
                      Allowance
                    </Button>
                    <div>
                      {this.state.loading1 ? <Loading /> : ''}
                    </div>
                  </Form>
                  <Card.Text>
                    {this.state.allowance}
                  </Card.Text>
                </Card.Body>
              </Card>

              <Card>
                <Card.Body>
                  <Card.Title>Check Balance</Card.Title>
                  <Card.Text>
                    Check the account balance
                  </Card.Text>
                  <Form onSubmit={this.checkBalance}>
                    <Form.Group>
                      <Form.Label>Account Address</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ balanceAccount: event.target.value })}
                        type="text"
                        placeholder="Ethereum address"
                      />
                    </Form.Group>
                    <Button variant="success" type="submit">
                      Balance Of
                    </Button>
                    <div>
                      {this.state.loading2 ? <Loading /> : ''}
                    </div>
                  </Form>
                  <Card.Text>
                    {this.state.balance}
                  </Card.Text>
                </Card.Body>
              </Card>
            </CardDeck>
          </div>
          <div style={{ marginTop: "30px" }}>
            <CardDeck>
              <Card>
                <Card.Body>
                  <Card.Title>Approve</Card.Title>
                  <Card.Text>
                    Approve the spender to withdraw the specified amount from your account.
                    </Card.Text>
                  <Form onSubmit={this.approve}>
                    <Form.Group>
                      <Form.Label>Spender's Address</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ approveAddress: event.target.value })}
                        type="text" placeholder="Spender's ethereum address" />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ approveAmount: event.target.value })}
                        type="text" placeholder="Amount allowed" />
                    </Form.Group>
                    <Button variant="success" type="submit">
                      Approve
                    </Button>
                    <div>
                      {this.state.loading3 ? <Loading /> : ''}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
              <Card>
                <Card.Body>
                  <Card.Title>Transfer</Card.Title>
                  <Card.Text>
                    Send the specified amount of tokens to the recipient
                    </Card.Text>
                  <Form onSubmit={this.transfer}>
                    <Form.Group>
                      <Form.Label>Recipient's Address</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ transferTo: event.target.value })}
                        type="text"
                        placeholder="Recipient's ethereum address"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ transferAmount: event.target.value })}
                        type="text"
                        placeholder="Amount to be sent"
                      />
                    </Form.Group>
                    <Button variant="success" type="submit">
                      Transfer
                    </Button>
                    <div>
                      {this.state.loading4 ? <Loading /> : ''}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
              <Card>
                <Card.Body>
                  <Card.Title>Transfer From</Card.Title>
                  <Card.Text>
                    Send the specified amount from the owner's address to the spender's address.
                    </Card.Text>
                  <Form onSubmit={this.transferFrom}>
                    <Form.Group>
                      <Form.Label>Owner's Address</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ from: event.target.value })}
                        type="text"
                        placeholder="Owner's ethereum address"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Spender's Address</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ to: event.target.value })}
                        type="text"
                        placeholder="Spender's ethereum address"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        onChange={event => this.setState({ transferFromAmount: event.target.value })}
                        type="text"
                        placeholder="Amount to be sent"
                      />
                      <Form.Text className="text-muted">
                        The amount cannot be bigger than the approved allowance.
                       </Form.Text>
                    </Form.Group>
                    <Button variant="success" type="submit">
                      Transfer
                    </Button>
                    <div>
                      {this.state.loading5 ? <Loading /> : ''}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </CardDeck>
          </div>
        </div>
      </Container>
    )
  }
}
export default Tokens